const Paginator = require("_fil_local_addon/camc-cms-base/amc_paginator");
const queryString = require("qs");
const REGION_PARAM = "r";
const TAG_PARAM = "tag";
const PAGE_PARAM = "p";
const PER_PAGE_PARAM = "c";

(function ($) {
    function textSize(fontSize, fontFamily, text) {
        let span = document.createElement("span");
        let width = span.offsetWidth;
        span.style.visibility = "hidden";
        span.style.fontSize = fontSize;
        span.style.fontFamily = fontFamily;
        span.style.display = "inline-block";
        document.body.appendChild(span);
        if (typeof span.textContent != "undefined") {
            span.textContent = text;
        } else {
            span.innerText = text;
        }
        width = parseFloat(window.getComputedStyle(span).width) - width;
        document.body.removeChild(span);
        return width;
    }

    function resetRightMenuWidth(menu) {
        let userAgent = navigator.userAgent;
        if (
            (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1) ||
            userAgent.indexOf("Trident") > -1 ||
            userAgent.indexOf("Windows Phone") > -1
        ) {
            let rightMenu = $(".cascader-menu-right");
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            if (rightMenu && rightMenu.length > 0) {
                if (rightMenu[0].scrollHeight > rightMenu[0].clientHeight) {
                    if (Foundation.MediaQuery.is("small only")) {
                        rightMenu.css("width", vw - 180);
                    } else {
                        rightMenu.css("width", "+=17");
                    }
                } else if (rightMenu[0].scrollHeight == 0 && rightMenu[0].clientHeight == 0) {
                    if (menu != null) {
                        let longText = "";
                        $.each(menu[0].childNodes, function (index, item) {
                            if (item.innerText.length > longText.length) {
                                longText = item.innerText;
                            }
                        });
                        let longestTextWidth = textSize("18px", "Noto Sans SC,Noto Sans CJK SC,sans-serif", longText);
                        let width = longestTextWidth + 80 + 17;
                        if (Foundation.MediaQuery.is("small only")) {
                            width = vw - 180;
                        }
                        rightMenu.css("width", width);
                    }
                }
            }
        }
    }

    function Cascader(opt) {
        var def = {
            displayField: "name",
            valueField: "id",
            separator: "/",
            data: [],
        };
        this.el = opt.el;
        this.$el = $(this.el);
        this.data = opt.data;
        this.option = $.extend(def, opt);
        this.checkeditems = [];
        this.inited = false;

        this.init();
    }
    Cascader.prototype.init = function () {
        this.wrapEl();
        this.creatDropdownEl();
        // var $menu = this.creatCascaderMenu(this.data);
        // this.$dropdownEl.append($menu);
        this.initValue();
        this.inited = true;
    };
    Cascader.prototype.wrapEl = function () {
        var me = this;
        var $showEl = $(
            '<div class="input-group">' +
                '<input type="text" class="form-control" readonly/>' +
                '<span class="input-group-addon"><i class="glyphicon glyphicon-chevron-down"></i></span>' +
                "</div>",
        );
        me.$el.wrap('<div class="cascader-wrapper"></div>').hide();
        me.$el.after($showEl);
        me.$showInput = $("input", $showEl);
        me.$triggerEl = $(".input-group-addon", $showEl);
    };
    Cascader.prototype.creatDropdownEl = function () {
        this.$dropdownEl = $('<div class="cascader-dropdown-container"></div>');
        $("body").append(this.$dropdownEl);
        this.initEvent();
    };
    Cascader.prototype.computeDropdownElPosition = function () {
        var position = this.$showInput.offset();
        var elH = this.$showInput.outerHeight(true); // 计算input带边框的高度
        this.$dropdownEl.css({
            left: position.left,
            top: position.top + elH,
        });
    };
    Cascader.prototype.creatCascaderMenu = function (data, selectItem, hasChild) {
        var $menu;
        if (hasChild) {
            $menu = $('<ul class="cascader-menu-right"></ul>');
        } else {
            $menu = $('<ul class="cascader-menu"></ul>');
        }

        $.each(data, function (index, item) {
            var $item = $('<li class="cascader-menu-item">' + item.name + "</li>");
            if (item.children) {
                $item.addClass("cascader-menu-item-expand");
                $item.append('<i class="glyphicon glyphicon-menu-right"></i>');
            }
            if (selectItem && item == selectItem) {
                $item.addClass("cascader-menu-item-active");
            }
            $item.data("cascader-data", item);
            $menu.append($item);
        });
        return $menu;
    };
    Cascader.prototype.initEvent = function () {
        var me = this;
        var timer;
        var newCheckeditems = [];
        me.$dropdownEl.on("click", "li", function (event) {
            var $this = $(this);
            var data = $this.data("cascader-data");
            var $parent = $this.parent();
            var parentIndex = $parent.index();
            // var checkeditems = me.checkeditems;

            if (timer) {
                clearTimeout(timer);
            }

            if ($this.hasClass("cascader-menu-item-active")) {
                if (data.children) {
                    return;
                } else {
                    me.hideDropdown();
                }
            }

            $this.addClass("cascader-menu-item-active").siblings().removeClass("cascader-menu-item-active");
            $parent.nextAll().remove();

            if (newCheckeditems.length > parentIndex) {
                newCheckeditems = newCheckeditems.slice(0, parentIndex);
            }
            newCheckeditems.push(data);

            if (data.children) {
                var $nextMenu = me.creatCascaderMenu(data.children, "", true);
                $parent.after($nextMenu);
                resetRightMenuWidth(null);
            } else {
                me.checkeditems = newCheckeditems;
                me.setValue();
                me.hideDropdown();
            }
        });
        me.$showInput.on("focus", function (event) {
            event.stopPropagation();
            me.showDropdown();
        });

        me.$showInput.on("click", function (event) {
            event.stopPropagation();
        });
        me.$triggerEl.on("click", function (event) {
            event.stopPropagation();
            if (me.$dropdownEl.is(":visible")) {
                me.hideDropdown();
            } else {
                me.showDropdown();
            }
        });
        $(document).on("click", function (event) {
            var target = event.target;
            if ($(target).hasClass("cascader-menu-item") || $(target).hasClass("cascader-menu-right")) {
                return;
            }
            timer = setTimeout(function () {
                me.hideDropdown();
            }, 0);
        });
    };
    Cascader.prototype.showDropdown = function () {
        this.computeDropdownElPosition();
        this.$dropdownEl.show();
    };
    Cascader.prototype.hideDropdown = function () {
        this.$dropdownEl.hide();
    };
    Cascader.prototype.setValue = function () {
        var me = this;
        var option = me.option;
        var showProp = option.displayField;
        var submitProp = option.valueField;
        var showValue = [];
        var len = me.checkeditems.length;
        var submitValue = len > 0 ? me.checkeditems[len - 1][submitProp] : "";
        $.each(me.checkeditems, function (index, item) {
            showValue = [];
            showValue.push(item[showProp]);
        });
        // me.$showInput.val(showValue.join(option.separator));
        me.$showInput.val(showValue);
        // 不是初始化完成前调用setValue，不触发事件；
        if (!me.inited || me.oldSubmitValue == submitValue) {
            return;
        }
        me.oldSubmitValue = submitValue;
        me.$el.val(submitValue);
        me.$el.trigger("change.cascader", [submitValue, me.checkeditems]);

        const articleFilter = new CAMCArticleListFilter($(".camc-cn-article-list"), false);
        articleFilter.articleHandlerByTag(submitValue);
        articleFilter.updateURLBySetValue(submitValue);
    };
    Cascader.prototype.clearValue = function () {
        var me = this;
        me.checkeditems = [];
        me.setValue();
    };
    Cascader.prototype.initValue = function () {
        var me = this;
        var option = me.option;
        var val = me.$el.val().trim();

        if (option.value) {
            val = option.value;
        }

        var path = getPath(me.data, val, option.valueField);
        me.oldSubmitValue = val;
        me.checkeditems = path;
        me.initMenu(me.checkeditems);
        me.setValue();
    };
    Cascader.prototype.initMenu = function () {
        var me = this;
        var data = me.data;
        var $menu;

        if (me.checkeditems.length === 0) {
            $menu = me.creatCascaderMenu(me.data, "", false);
            me.$dropdownEl.append($menu);
        }
        $.each(me.checkeditems, function (index, item) {
            if (index == 0) {
                $menu = me.creatCascaderMenu(data, item);
            } else {
                $menu = me.creatCascaderMenu(data, item, true);
            }
            me.$dropdownEl.append($menu);
            resetRightMenuWidth(null);
            if (item.children) {
                data = item.children;
            }
        });
    };
    Cascader.prototype.val = function () {
        var me = this;
        var data = me.data;
        var $menu;

        if (arguments.length === 0) {
            return me.oldSubmitValue;
        } else {
            var val = arguments[0];
            var path = getPath(me.data, val, me.option.valueField);
            me.checkeditems = path;
            me.setValue();

            me.creatDropdownEl();

            $.each(me.checkeditems, function (index, item) {
                if (index == 0) {
                    $menu = me.creatCascaderMenu(data, item);
                } else {
                    $menu = me.creatCascaderMenu(data, item, true);
                }
                me.$dropdownEl.append($menu);
                resetRightMenuWidth($menu);
                if (item.children) {
                    data = item.children;
                }
            });
        }
    };

    function getPath(data, val, key) {
        var obj = [];
        for (var i = 0, l = data.length; i < l; i++) {
            var item = data[i];
            if (item[key].indexOf(val) >= 0) {
                obj.push(item);
                break;
            } else if (item.children) {
                var subPath = getPath(item.children, val, key);
                if (subPath.length > 0) {
                    obj = obj.concat(item, subPath);
                }
            }
        }
        return obj;
    }

    $.fn.cascader = function () {
        var args = Array.prototype.slice.call(arguments);
        var opt;
        var res;
        this.each(function () {
            var $this = $(this);
            var cascader = $this.data("cascader");
            if (cascader) {
                if (args.length > 0) {
                    opt = args[0];
                }
                if ($.type(opt) === "string") {
                    res = cascader[opt](args.slice(1));
                    if (res !== undefined) {
                        return false;
                    }
                }
            } else {
                if (args.length > 0) {
                    opt = args[0];
                }
                if ($.isPlainObject(opt)) {
                    var option = $.extend(
                        {
                            el: this,
                        },
                        opt,
                    );
                    $this.data("cascader", new Cascader(option));
                }
            }
        });
        if (res !== undefined) {
            return res;
        } else {
            return this;
        }
    };

    $(window).on("resize", windowResizingEvent);

    function windowResizingEvent() {
        $(".cascader-dropdown-container").css("display", "none");
    }
})($);

$(function () {
    var fundManagerMap = new Map();
    var fundAssetTypeMap = new Map();
    var fundNameMap = new Map();
    fundNameMap.set("全部", "allFundNames");
    fundManagerMap.set("全部", "allManagers");
    fundAssetTypeMap.set("全部", "allFundTypes");

    $(".camc-cn-article-list .cell.camc-article .fund-tag").each(function () {
        let fundTag = $(this).find("a").text();
        let fundDescription = $(this).find(".fund-description").text();
        let href = $(this).find("a").attr("href");
        if (fundTag.length && fundDescription.length) {
            if (fundDescription.trim() === "fund-name") {
                if (!fundNameMap.has(fundTag)) {
                    fundNameMap.set(fundTag, href);
                }
            } else {
                if (!fundAssetTypeMap.has(fundTag)) {
                    fundAssetTypeMap.set(fundTag, href);
                }
            }
        }
    });

    $(".camc-cn-article-list .cell.camc-article .author-tag").each(function () {
        let authorTag = $(this).find(".author-name").text();
        let authorID = $(this).find(".author-id").text();
        if (!fundManagerMap.has(authorTag) && authorTag.length && authorID.length) {
            fundManagerMap.set(authorTag, authorID);
        }
    });

    var filterData = [
        {
            id: "all",
            name: "全部",
        },
    ];

    let arrayFundManager = [];
    let arrayFundAssetType = [];
    let arrayFundName = [];

    fundManagerMap.forEach(function (key, value, fundManagerMap) {
        let fundManager = {
            name: value,
            id: key,
        };
        arrayFundManager.push(fundManager);
    });
    fundAssetTypeMap.forEach(function (key, value, fundAssetTypeMap) {
        let fundManager = {
            name: value,
            id: key,
        };
        arrayFundAssetType.push(fundManager);
    });
    fundNameMap.forEach(function (key, value, fundNameMap) {
        let fundManager = {
            name: value,
            id: key,
        };
        arrayFundName.push(fundManager);
    });
    if (fundManagerMap && fundManagerMap.size) {
        filterData.push({
            id: "allM",
            name: "基金经理",
            children: arrayFundManager,
        });
    }
    if (fundAssetTypeMap && fundAssetTypeMap.size) {
        filterData.push({
            id: "allT",
            name: "资产类型",
            children: arrayFundAssetType,
        });
    }
    if (fundNameMap && fundNameMap.size) {
        filterData.push({
            id: "allF",
            name: "基金名称",
            children: arrayFundName,
        });
    }

    $("#cascade-article-filter-input").cascader({
        displayField: "name",
        valueField: "id",
        separator: "/",
        data: filterData,
    });

    //mobile device cannot showup the input panel
    // $('#cascade-article-filter-input').focus(function(){
    //     $(document.activeElement).on('blur');
    // });

    window.setFilterValue = function (filterValue) {
        let fundManagerReg = new RegExp("[\u4e00-\u9fa5]+");
        if (fundManagerReg.test(filterValue)) {
            let exsitManager = false;
            fundManagerMap.forEach(function (key, value, fundManagerMap) {
                if (filterValue == value.trim()) {
                    $("#cascade-article-filter-input").cascader("val", key);
                    exsitManager = true;
                }
            });
            if (!exsitManager) {
                $("#cascade-article-filter-input").cascader("val", "all");
            }
        } else {
            $("#cascade-article-filter-input").cascader("val", filterValue);
        }
    };

    if ($(".fil-article-list.camc-cn-article-list").length) {
        const articleFilter = new CAMCArticleListFilter($(".camc-cn-article-list"), true);
    }
});

class CAMCArticleListFilter extends Paginator {
    constructor(rootEl, opts = {}) {
        super(rootEl, opts);
        this.rootEl = rootEl;
        this.region = "all";
        this.tag = "all";
        this.$results = $(this.rootEl).find(".camc-article").not(":hidden");
        this.$articles = this.$results.find(".fil-article-list__card");
        this.bindPageChangingEvent();
        this.bindArticleFilteringEvents();
        this.bindArticleRegionTag();
        // this.articleHandlerByTag();
        // $navigation -- container for navigation button elements
        this.$navigation = $(this.rootEl).find(".paginator__nav");

        // $perPageInputContainer -- container of the $perPageInput
        this.$perPageInputContainer = $(this.rootEl).find(".paginator__per-page");
        this.page = parseInt(this.getUrlParameters().page);
        this.perPage = parseInt(this.getUrlParameters().perPage);
        this.buildNavigation();

        if (opts) {
            this.getURLRegion();
        }
    }

    aritcleRegionFilter() {
        $("#article-filter-select").val(this.region);
        $("#article-filter-select").change();
        super.rebuild();
    }

    aritcleTagFilter() {
        setFilterValue(this.tag);
    }

    bindPageChangingEvent() {
        const filter = this;
        $("li.paginator__nav-button--digit").on("click", function () {
            if (filter.page != $(this).text()) {
                filter.setPage($(this).text());
            }
        });
    }

    bindArticleFilteringEvents() {
        const $select = $("select#article-filter-select");
        const dict = new Set();
        const filter = this;
        let option = "";

        $(".camc-cn-article-list .cell.camc-article").each(function () {
            let regionTag = $(this).find(".camc-cn-article-region").text();
            if (!dict.has(regionTag) && regionTag.length) {
                let $optionDom = $(`<option value="${regionTag}">${regionTag}</option>`);
                $optionDom.appendTo($select);
                dict.add(regionTag);
            }
        });

        $select.on("change", function () {
            option = $(this).find("option:selected").val();
            filter.articleHandler(option);
            $select.blur();
        });
    }

    articleHandler(option) {
        if (option == "all") {
            $(".camc-cn-article-list .cell.camc-article")
                .show()
                .each(function () {
                    $(this).find(".card").addClass("fil-article-list__card");
                });
        } else {
            $(".camc-cn-article-list .cell.camc-article").each(function () {
                if ($(this).find(".camc-cn-article-region").text() != option) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        }
        this.page = 0;
        super.rebuild();
    }

    articleHandlerByTag(tag) {
        let fundManagerReg = new RegExp("[\u4e00-\u9fa5]+");
        if (fundManagerReg.test(tag)) {
            return;
        }
        const filter = this;
        var fundManagerMap = new Map();
        fundManagerMap.set("全部", "allManagers");

        $(".camc-cn-article-list .cell.camc-article .author-tag").each(function () {
            let authorTag = $(this).find(".author-name").text();
            let authorID = $(this).find(".author-id").text();
            if (!fundManagerMap.has(authorTag) && authorTag.length && authorID.length) {
                fundManagerMap.set(authorTag, authorID.trim());
            }
        });

        if (tag) {
            tag = tag.trim();
        }
        if (tag == "all") {
            $(".camc-cn-article-list .cell.camc-article").each(function () {
                $(this).show();
            });
        } else {
            let fundManagerArray = [];
            fundManagerMap.forEach(function (value) {
                fundManagerArray.push(value);
            });

            if (fundManagerArray.indexOf(tag) >= 0) {
                if (tag == "allManagers") {
                    $(".camc-cn-article-list .cell.camc-article").each(function () {
                        let showFlag = false;
                        $(this)
                            .find(".author-tag")
                            .each(function () {
                                let authorID = $(this).find(".author-id").text();
                                if (authorID) {
                                    showFlag = true;
                                }
                            });
                        filter.showListItem($(this), showFlag);
                    });
                } else {
                    $(".camc-cn-article-list .cell.camc-article ").each(function () {
                        let showFlag = false;
                        $(this)
                            .find(".author-tag")
                            .each(function () {
                                let authorID = $(this).find(".author-id").text();
                                if (authorID.indexOf(tag) >= 0) {
                                    showFlag = true;
                                }
                            });
                        filter.showListItem($(this), showFlag);
                    });
                }
            } else {
                if (tag == "allFundNames" || tag == "allFundTypes") {
                    $(".camc-cn-article-list .cell.camc-article")
                        .show()
                        .each(function () {
                            let showFlag = false;
                            $(this)
                                .find(".fund-tag")
                                .each(function () {
                                    let fundDescription = $(this).find(".fund-description").text().trim();
                                    if (tag == "allFundNames" && fundDescription == "fund-name") {
                                        showFlag = true;
                                    }
                                    if (tag == "allFundTypes" && fundDescription == "fund-type") {
                                        showFlag = true;
                                    }
                                });
                            filter.showListItem($(this), showFlag);
                        });
                } else {
                    $(".camc-cn-article-list .cell.camc-article").each(function () {
                        let showFlag = false;
                        $(this)
                            .find(".fund-tag")
                            .each(function () {
                                let tagHref = $(this).find("a").attr("href");
                                if (tagHref.indexOf(tag) >= 0) {
                                    showFlag = true;
                                }
                            });
                        filter.showListItem($(this), showFlag);
                    });
                }
            }
        }
        this.page = 0;
        if ($("#per-page-dropdown").val()) {
            this.perPage = $("#per-page-dropdown").val();
        }
        super.rebuild();
    }

    bindArticleRegionTag() {
        $("span.camc-cn-article-region").on("click", function () {
            const regionTag = $(this).text();
            $(`#article-filter-select option[value=${regionTag}]`).prop("selected", true);
            $(`#article-filter-select option[value=${regionTag}]`).trigger("change");
        });
    }

    getResultsForPage(page) {
        return [page * this.perPage, (page + 1) * this.perPage - 1];
    }

    getTotalResults() {
        this.$results = $(this.rootEl).find(".camc-article").not(":hidden");
        this.$articles = this.$results.find(".fil-article-list__card");
        return this.$articles.length;
    }

    buildResults(bounds) {
        const [min, max] = bounds;
        this.$articles.each((i, el) => {
            const visible = min <= i && i <= max;
            $(el).toggleClass("hide", !visible);
        });
    }

    setPage(page) {
        super.setPage(page);
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            400,
        );
    }

    setPerPage(perPage) {
        super.setPerPage(perPage);
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            400,
        );
    }

    showListItem(instance, flag) {
        if (flag) {
            instance.show();
        } else {
            instance.hide();
        }
    }

    getURLRegion() {
        if (this.disableURL) {
            return;
        }

        let parsed = queryString.parse(window.location.search, {
            ignoreQueryPrefix: true,
        });
        let regionParam = parsed[REGION_PARAM];
        let tagParam = parsed[TAG_PARAM];

        if (regionParam && regionParam.length > 0) {
            this.region = regionParam;
            if (this.region !== "all") {
                this.aritcleRegionFilter();
            }
        }

        if (tagParam && tagParam.length > 0) {
            this.tag = tagParam;
            if (this.tag !== "all") {
                this.aritcleTagFilter();
                this.articleHandlerByTag(tagParam);
            }
        }
    }

    /**
     * Generate the HTML for the paginator navigation. Includes the next and
     * previous page arrow buttons, and digit buttons for navigating to
     * individual pages.
     * overwrite the Paginator method
     */
    buildNavigation() {
        const buttonCount = super.getNavButtonCount();
        const maxPages = super.getMaxPages();
        const total = this.getTotalResults();

        // Hide the entire pagination if there are not multiple pages
        this.$navigation.toggleClass("hide", maxPages < 2);

        // Hide the container of the per page input if there are less than 10 items
        this.$perPageInputContainer.toggleClass("hide", total < 11);

        // Calculate the smallest value to display as a pagination button
        let startAt;
        startAt = this.page - Math.floor(buttonCount / 2);
        startAt = Math.min(startAt, maxPages - buttonCount);
        startAt = Math.max(0, startAt);

        // Determine whether to show the arrows
        $(".paginator__nav-button--prev").toggleClass("invisible", this.page == 0 || maxPages <= buttonCount);

        $(".paginator__nav-button--next").toggleClass("invisible", this.page == maxPages - 1 || maxPages <= buttonCount);

        // Remove the existing digit buttons
        this.$navigation.find(".paginator__nav-button--digit").off("click").remove();

        // Generate new digit buttons
        const limit = Math.min(maxPages, buttonCount);
        const nextButton = this.$navigation.find(".paginator__nav-button--next");

        for (let i = 0; i < limit; i++) {
            super.buildNavButton(startAt + i).insertBefore(nextButton);
        }
    }

    /**
     * Update the query string to record the pagination state. Use push state to
     * record the URL change in the browser history. Only push a new history
     * state if the URL has actually changed.
     */
    updateURLBySetValue(tag) {
        if (this.disableURL) {
            return;
        }

        let parsed = queryString.parse(window.location.search, {
            ignoreQueryPrefix: true,
        });

        const hasChanged = parsed[PAGE_PARAM] != this.page || parsed[PER_PAGE_PARAM] != this.perPage || parsed[TAG_PARAM] != tag;

        if (hasChanged) {
            parsed[TAG_PARAM] = tag.trim();
            parsed[PAGE_PARAM] = this.page;
            parsed[PER_PAGE_PARAM] = this.perPage;
            history.pushState({}, "", `?${queryString.stringify(parsed)}`);
        }
    }

    getUrlParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get(PAGE_PARAM) || super.page;
        const perPage = urlParams.get(PER_PAGE_PARAM) || super.perPage;
        return { page: page, perPage: perPage };
    }
}
